<script setup lang="ts">
//#region types
export interface Item {
  name: string;
  key: string;
  routeName: string;
}

interface Props {
  list: Item[];
  params: Record<string, string>;
  query: Record<string, string>;
}
//#endregion

//#region define
const props = defineProps<Props>();
//#endregion
</script>

<template>
  <div class="card-navigation">
    <div class="t:flex t:items-center t:space-x-16">
      <RouterLink
        v-for="item in props.list"
        :key="item.key"
        :to="{
          name: item.routeName,
          params: props.params,
          query: props.query,
        }"
        :title="item.name"
        class="card-navigation__item"
        active-class="card-navigation__item_active"
      >
        {{ item.name }}
      </RouterLink>
    </div>
  </div>
</template>

<style lang="scss">
.card-navigation {
  border-bottom: 1px solid var(--border-divider);
  &__item {
    padding-bottom: 16px;
    border-bottom: 2px solid transparent;
    &:after {
      display: block;
      content: attr(title);
      font-weight: 700;
      height: 0;
      overflow: hidden;
      visibility: hidden;
    }
    &:hover,
    &_active {
      font-weight: 500;
    }
    &_active {
      border-color: var(--border-focused);
    }
  }
}
</style>
